import React, { useRef, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

export const OCCASIONS_LIST = [
  { to: "/birthday",          label: "Birthday",       icon: "🎂" },
  { to: "/kids",              label: "Kids Birthday",  icon: "🎈" },
  { to: "/anniversary",       label: "Anniversary",    icon: "💞" },
  { to: "/bride-to-be",       label: "Bride to Be",    icon: "👰" },
  { to: "/proposals",         label: "Proposals",      icon: "💍" },
  { to: "/movie-preview",     label: "Movie Preview",  icon: "🎬" },
];

export default function OccasionsNav({ currentPath }) {
  const location = useLocation();
  const path = currentPath || location.pathname;
  const activeRef = useRef(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (activeRef.current && scrollRef.current) {
      const container = scrollRef.current;
      const el = activeRef.current;
      const scrollLeft = el.offsetLeft - container.offsetWidth / 2 + el.offsetWidth / 2;
      container.scrollTo({ left: Math.max(0, scrollLeft), behavior: "smooth" });
    }
  }, [path]);

  const isCurrentActive = (itemTo) => {
    if (itemTo === "/bride-to-be") {
      return path === "/bride-to-be" || path === "/bride to be" || path === "/bridetobe";
    }
    if (itemTo === "/proposals") {
      return path === "/proposals" || path === "/proposal";
    }
    return path === itemTo;
  };

  return (
    <>
      <style>{`
        .occ-nav-bar {
          background: rgba(18, 0, 32, 0.92);
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
          border-bottom: 1px solid rgba(201, 168, 76, 0.22);
          position: sticky;
          top: 0;
          z-index: 100;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
          width: 100%;
        }
        .occ-nav-inner {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          overflow-x: auto;
          overflow-y: hidden;
          padding: 10px 16px;
          scrollbar-width: none;
          -ms-overflow-style: none;
          -webkit-overflow-scrolling: touch;
          scroll-behavior: smooth;
          max-width: 1100px;
          margin: 0 auto;
        }
        .occ-nav-inner::-webkit-scrollbar {
          display: none;
        }
        @media (max-width: 900px) {
          .occ-nav-inner {
            justify-content: flex-start;
          }
        }
        .occ-nav-pill {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          padding: 8px 16px;
          border-radius: 50px;
          font-family: 'DM Sans', sans-serif;
          font-size: 12.5px;
          font-weight: 600;
          letter-spacing: 0.3px;
          text-decoration: none;
          white-space: nowrap;
          color: rgba(255, 255, 255, 0.78);
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.12);
          transition: all 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);
          flex-shrink: 0;
          user-select: none;
          cursor: pointer;
        }
        .occ-nav-pill:hover {
          color: #E8D5A0;
          background: rgba(94, 14, 115, 0.45);
          border-color: rgba(201, 168, 76, 0.45);
          transform: translateY(-1px);
        }
        .occ-nav-pill.active {
          color: #FFF;
          background: linear-gradient(135deg, #5E0E73 0%, #7B1A94 50%, #C9A84C 100%);
          border-color: #C9A84C;
          box-shadow: 0 4px 14px rgba(201, 168, 76, 0.35), 0 0 10px rgba(94, 14, 115, 0.4);
          transform: translateY(-1px);
        }
        .occ-nav-pill:active {
          transform: scale(0.96);
        }
        .occ-nav-pill-icon {
          font-size: 15px;
          line-height: 1;
        }
        .occ-nav-pill-label {
          line-height: 1.2;
        }
        @media (max-width: 768px) {
          .occ-nav-bar {
            top: 0;
          }
          .occ-nav-pill {
            font-size: 12px;
            padding: 7px 13px;
            gap: 6px;
          }
          .occ-nav-pill-icon {
            font-size: 14px;
          }
        }
      `}</style>
      <nav className="occ-nav-bar" aria-label="Celebration Occasions">
        <div className="container">
          <div className="occ-nav-inner" ref={scrollRef}>
            {OCCASIONS_LIST.map((item) => {
              const active = isCurrentActive(item.to);
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  ref={active ? activeRef : null}
                  className={`occ-nav-pill${active ? " active" : ""}`}
                >
                  <span className="occ-nav-pill-icon">{item.icon}</span>
                  <span className="occ-nav-pill-label">{item.label}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </nav>
    </>
  );
}
